import { useState } from 'react';
import { Card } from '../../components/Card/Card';
import { usePutGeminiKey } from '../../store/queryHooks';
import { useUiStore } from '../../store/ui';
import styles from './GeminiKeyForm.module.css';

interface Props {
  isSet: boolean;
}

export function GeminiKeyForm({ isSet }: Props) {
  const [key, setKey] = useState('');
  const put = usePutGeminiKey();
  const setToast = useUiStore((s) => s.setToast);

  async function onSave() {
    try {
      await put.mutateAsync({ key });
      setToast(key === '' ? 'Gemini-nøgle ryddet' : 'Gemini-nøgle gemt');
      setKey('');
    } catch {
      setToast('Kunne ikke gemme nøglen');
    }
  }

  return (
    <Card className={styles.card}>
      <div className={styles.head}>
        <div className={styles.badge}>✨</div>
        <div>
          <h2 className={styles.title}>Gemini API-nøgle</h2>
          <p className={styles.sub}>
            Bruges til at drive økonomi-guiden med rigtige, personlige svar.
          </p>
        </div>
      </div>
      <div className={styles.form}>
        <label className={styles.label} htmlFor="gemini-key">
          Din nøgle
        </label>
        <div className={styles.row}>
          <input
            id="gemini-key"
            className={styles.input}
            type="password"
            placeholder={isSet ? 'Nøgle gemt (indtast ny for at overskrive)' : 'AIza…'}
            value={key}
            onChange={(e) => setKey(e.target.value)}
          />
          <button className={styles.save} onClick={onSave} disabled={put.isPending}>
            Gem
          </button>
        </div>
        {isSet && (
          <div className={styles.status}>
            <span>✓</span> Nøgle gemt — guiden er aktiv
          </div>
        )}
        <p className={styles.note}>
          Nøglen krypteres på serveren og sendes aldrig tilbage til browseren. Hent din nøgle på{' '}
          <a href="https://aistudio.google.com/apikey" target="_blank" rel="noreferrer">
            aistudio.google.com/apikey
          </a>
          .
        </p>
      </div>
    </Card>
  );
}
